"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatWithZero = function (value) {
    return "" + (value < 10 ? '0' : '') + value;
};
exports.formatValue = function (value, withTime, is12Hours, texts) {
    var result = formatWithZero(value.getDate()) + "/" + formatWithZero(value.getMonth() + 1) + "/" + value.getFullYear();
    if (withTime) {
        var hours = String(value.getHours());
        var timePeriod = value.getHours() > 11 ? texts.pm : texts.am;
        if (is12Hours) {
            hours = "" + (value.getHours() > 12 ? value.getHours() - 12 : value.getHours());
            if (hours === '0') {
                hours = '12';
            }
        }
        result += " " + hours + ":" + formatWithZero(value.getMinutes());
        if (is12Hours) {
            result += " " + timePeriod;
        }
    }
    return result;
};
//# sourceMappingURL=formatValue.js.map